export const LIST_MASTER_DATA_PROFILE_REQUEST =
  'LIST_MASTER_DATA_PROFILE_REQUEST'
export const LIST_MASTER_DATA_PROFILE_SUCCESS =
  'LIST_MASTER_DATA_PROFILE_SUCCESS'
export const LIST_MASTER_DATA_PROFILE_FAIL = 'LIST_MASTER_DATA_PROFILE_FAIL'

export const LIST_PROFILE_CONFIG_REQUEST = 'LIST_PROFILE_CONFIG_REQUEST'
export const LIST_PROFILE_CONFIG_SUCCESS = 'LIST_PROFILE_CONFIG_SUCCESS'
export const LIST_PROFILE_CONFIG_FAIL = 'LIST_PROFILE_CONFIG_FAIL'

export const LIST_SYNC_PROJECT_LOG_REQUEST = 'LIST_SYNC_PROJECT_LOG_REQUEST'
export const LIST_SYNC_PROJECT_LOG_SUCCESS = 'LIST_SYNC_PROJECT_LOG_SUCCESS'
export const LIST_SYNC_PROJECT_LOG_FAIL = 'LIST_SYNC_PROJECT_LOG_FAIL'

export const LIST_LAST_PROJECT_SYNC_REQUEST = 'LIST_LAST_PROJECT_SYNC_REQUEST'
export const LIST_LAST_PROJECT_SYNC_SUCCESS = 'LIST_LAST_PROJECT_SYNC_SUCCESS'
export const LIST_LAST_PROJECT_SYNC_FAIL = 'LIST_LAST_PROJECT_SYNC_FAIL'

export const CREATE_SYNC_PROFILE_CONFIG_REQUEST =
  'CREATE_SYNC_PROFILE_CONFIG_REQUEST'
export const CREATE_SYNC_PROFILE_CONFIG_SUCCESS =
  'CREATE_SYNC_PROFILE_CONFIG_SUCCESS'
export const CREATE_SYNC_PROFILE_CONFIG_FAIL = 'CREATE_SYNC_PROFILE_CONFIG_FAIL'

export const CREATE_SYNC_PROFILE_CONFIG_BY_ID_REQUEST =
  'CREATE_SYNC_PROFILE_CONFIG_BY_ID_REQUEST'
export const CREATE_SYNC_PROFILE_CONFIG_BY_ID_SUCCESS =
  'CREATE_SYNC_PROFILE_CONFIG_BY_ID_SUCCESS'
export const CREATE_SYNC_PROFILE_CONFIG_BY_ID_FAIL =
  'CREATE_SYNC_PROFILE_CONFIG_BY_ID_FAIL'

export const CREATE_SYNC_PROJECT_DATA_REQUEST =
  'CREATE_SYNC_PROJECT_DATA_REQUEST'
export const CREATE_SYNC_PROJECT_DATA_SUCCESS =
  'CREATE_SYNC_PROJECT_DATA_SUCCESS'
export const CREATE_SYNC_PROJECT_DATA_FAIL = 'CREATE_SYNC_PROJECT_DATA_FAIL'

export const CREATE_SYNC_BRANCH_SERVICE_REQUEST =
  'CREATE_SYNC_BRANCH_SERVICE_REQUEST'
export const CREATE_SYNC_BRANCH_SERVICE_SUCCESS =
  'CREATE_SYNC_BRANCH_SERVICE_SUCCESS'
export const CREATE_SYNC_BRANCH_SERVICE_FAIL = 'CREATE_SYNC_BRANCH_SERVICE_FAIL'

export const CREATE_SYNC_BRANCH_PACKAGE_REQUEST =
  'CREATE_SYNC_BRANCH_PACKAGE_REQUEST'
export const CREATE_SYNC_BRANCH_PACKAGE_SUCCESS =
  'CREATE_SYNC_BRANCH_PACKAGE_SUCCESS'
export const CREATE_SYNC_BRANCH_PACKAGE_FAIL = 'CREATE_SYNC_BRANCH_PACKAGE_FAIL'

export const RE_SYNC_DATA_REQUEST = 'RE_SYNC_DATA_REQUEST'
export const RE_SYNC_DATA_SUCCESS = 'RE_SYNC_DATA_SUCCESS'
export const RE_SYNC_DATA_FAIL = 'RE_SYNC_DATA_FAIL'